// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__XMdsc","Orange":"Button_Orange__4NCR8","Blue":"Button_Blue__JzcAh","disabled":"Button_disabled__DkgJ+"};